import AppFooterBg from "assets/footer.jpg";
import "./index.scss";

const AppFooter = () => {
  return (
    <div className="app-footer">
      <img src={AppFooterBg} alt="footer" />
      <div className="copyright-wrap">
        版权所有&copy;LADY N{" "}
        <a href="https://beian.miit.gov.cn" target="_blank" rel="noreferrer">
          {" "}
          粤ICP备2021009033号-1
        </a>
      </div>
    </div>
  );
};

export default AppFooter;
